import { Navigate, Outlet } from 'react-router-dom';

const PatPrivateRoute = ({ allowedRoles }) => {
  const group = localStorage.getItem('group');

  return (
   allowedRoles.includes(group)
      ? <Outlet />
      : <Navigate to="/patient-login" replace />
  );
};

export default PatPrivateRoute;
